/**
 * Video list component JS.
 */

import { h, app } from 'hyperapp'
import { AllHtmlEntities as Entities } from 'html-entities';

if ( typeof staffData !== 'undefined' ) {
	( function( staffData ) {
		if ( ! document.getElementById( 'staff-directory' ) ) {
			return
		}

		/**
		 * Functions
		 */
		const groupAlphabetically = ( collection ) => {
			const grouped = collection.reduce( ( acc, item ) => {
				const firstLetter = item.LAST_NAME.charAt( 0 ).toLowerCase();

				if ( acc[ firstLetter ] ) {
					acc[ firstLetter ].push( item );
				} else {
					acc[ firstLetter ] = [ item ];
				}

				return acc;
			}, {} );

			for ( let group in grouped ) {
				grouped[ group ].sort( alphabetical )
			}

			return grouped;
		}

		const groupOfficesAlphabetically = ( collection ) => {
			const grouped = collection.reduce( ( acc, item ) => {
				const firstLetter = item.name.charAt( 0 ).toLowerCase();

				if ( acc[ firstLetter ] ) {
					acc[ firstLetter ].push( item );
				} else {
					acc[ firstLetter ] = [ item ];
				}

				return acc;
			}, {} );

			for ( let group in grouped ) {
				grouped[ group ].sort( alphabeticalOffice )
			}

			return grouped;
		}

		const alphabetical = ( a, b ) => {
			if ( a.FIRST_NAME && b.FIRST_NAME ) {
				const nameA = a.LAST_NAME + ', ' + a.FIRST_NAME;
				const nameB = b.LAST_NAME + ', ' + b.FIRST_NAME;

				return nameA.localeCompare( nameB );
			}

			return a.localeCompare( b );
		}

		const alphabeticalOffice = ( a, b ) => {
			return a.name.localeCompare( b.name );
		}

		const getOffices = ( state ) => {
			return state.map( ( item ) => {
				return Object.assign( item, {
					id: item.slug,
					name: item.name,
				} );
			} );
		}

		const formatPhoneNUmber = ( phone ) => {
			phone = phone.replace(/[^0-9]/g,'');

			const length = phone.length;

			if ( length === 10 ) {
				const parts = [];
				parts[0] = phone.substring( 0, 3 );
				parts[1] = phone.substring( 3, 6 );
				parts[2] = phone.substring( 6 );

				phone = parts.join( '-' );
			}

			if ( length === 11 ) {
				const parts = [];
				parts[0] = phone.substring( 0, 1 );
				parts[1] = phone.substring( 1, 4 );
				parts[2] = phone.substring( 4, 7 );
				parts[3] = phone.substring( 7 );

				phone = parts.join( '-' );
			}

			return phone;
		}

		const filterPrograms = ( collection, filters ) => {
			if ( ! filters ) {
				return collection;
			}

			if ( filters.search.value && collection.length ) {
				const search = filters.search.value.replace(/\s/g,'');

				collection = collection.filter( item => {
					const name = item.FIRST_NAME.toLowerCase() + item.LAST_NAME.toLowerCase();

					if ( name.indexOf( search.toLowerCase() ) !== -1 ) {
						return true;
					}

					if ( item.DEPARTMENT && item.DEPARTMENT.replace(/\s/g,'').toLowerCase().indexOf( search.toLowerCase() ) !== -1 ) {
						return true;
					}

					return false;
				} );
			}

			if ( filters.alphabet.value && collection.length ) {
				const alphabet = filters.alphabet.value;

				// Find staff that start with the alphabet value.
				collection = collection.filter( item => item.LAST_NAME.toLowerCase().indexOf( alphabet.toLowerCase() ) === 0 )
			}

			return collection;
		}

		const filterOffices = ( collection, filters ) => {
			if ( ! filters ) {
				return collection;
			}

			if ( filters.search.value && collection.length ) {
				const search = filters.search.value.replace(/\s/g,'');

				collection = collection.filter( item => {
					if ( item.name.toLowerCase().replace(/\s/g,'').indexOf( search.toLowerCase() ) !== -1 ) {
						return true;
					}

					return false;
				} );
			}

			if ( filters.alphabet.value && collection.length ) {
				const alphabet = filters.alphabet.value;

				// Find staff that start with the alphabet value.
				collection = collection.filter( item => item.name.toLowerCase().replace(/\s/g,'').indexOf( alphabet.toLowerCase() ) === 0 )
			}

			return collection;
		}

		const filtersEmpty = ( filters ) => {
			for ( var filter in filters ) {
				// If the string is not empty.
				if ( filters[ filter ].value.length > 0 ) {
					return false;
				}
			}

			return true;
		}

		/**
		 * App Components
		 */

		const alphabet = [
			'A',
			'B',
			'C',
			'D',
			'E',
			'F',
			'G',
			'H',
			'I',
			'J',
			'K',
			'L',
			'M',
			'N',
			'O',
			'P',
			'Q',
			'R',
			'S',
			'T',
			'U',
			'V',
			'W',
			'X',
			'Y',
			'Z'
		];

		const entities = new Entities();

		const staffAlphabetically = groupAlphabetically( staffData.staff );

		const state = {
			staff: staffData.staff,
			staffAlphabetically: staffAlphabetically,
			initialRender: true,
			// offices: getOffices( staffData.departments ),
			filters: {
				'search': { value: '' },
				'type': { value: 'staff' },
				'alphabet': { value: '' },
			}
		};

		const actions = {
			updateFilters: ( filter ) => ( state ) => {
				const nextState = Object.assign( {}, state );

				nextState.filters = Object.assign(
					{},
					state.filters,
					{
						[ filter.key ]: Object.assign(
							{},
							state.filters[ filter.key ],
							{ value: filter.value }
						)
					}
				);

				return nextState;
			},
			updateRender: ( value ) => ( state ) => {
				const nextState = Object.assign( {}, state, { initialRender: value } );

				return nextState;
			},
			clearFilters: () => ( state ) => {
				const nextState = Object.assign( {}, state );

				nextState.filters = Object.assign(
					{},
					{
						'search': { value: '' },
						'alphabet': { value: '' },
					}
				);

				return nextState;
			}
		};

		const view = ( state, actions ) => {
			return (
				<div class="staff-directory__container">
					<Filters actions={ actions } state={ state } />
					<AlphabetFilter state={ state } actions={ actions } />
					<ProgramList state={ state } actions={ actions } />
				</div>
			)
		}

		const Filters = ( { actions, state } ) => {
			const updateFilters = actions.updateFilters;
			const filters = state.filters;

			const updateField = ( filter ) => ( event ) => {
				const value = event.target.value;

				updateFilters( { key: filter, value: value } );
			}

			return (
				<div class="staff-directory__filters">
					<div class="staff-directory__searchbar">
						<label for="people-search" class="screen-reader-text">Search for staff.</label>
						<input id="people-search" oninput={ updateField( 'search' ) } type="search" class="staff-directory__searchbar-input" value={ state.filters.search.value } />
						<i class="icon-search staff-directory__searchbar-icon"></i>
					</div>
				</div>
			);
		}

		const TypeFilter = ( { filters, actions } ) => {
			const updateField = ( filter ) => ( event ) => {
				const value = event.target.dataset.id;

				actions.updateFilters( { key: filter, value: value } );
			}

			const OfficesTab = filters.type.value === 'offices' ? <button class="staff-directory__tab active" onclick={ updateField( 'type' ) } data-id="offices">Offices</button> : <button class="staff-directory__tab" onclick={ updateField( 'type' ) } data-id="offices">Offices</button>;
			const StaffTab = filters.type.value === 'staff' ? <button class="staff-directory__tab active" onclick={ updateField( 'type' ) } data-id="staff">Faculty & Staff</button>: <button class="staff-directory__tab" onclick={ updateField( 'type' ) } data-id="staff">Faculty & Staff</button>;

			return (
				<div class="staff-directory__tabs">
					{ OfficesTab }
					{ StaffTab }
				</div>
			)
		}

		const AlphabetFilter = ( { state, actions } ) => {
			const staffAlphabetically = groupAlphabetically( state.staff );
			const currentAlphabetLetter = state.filters.alphabet.value;
			const { updateFilters } = actions;

			const updateAlphabetFilter = ( event ) => {
				let value = event.target.textContent;
				const filter = 'alphabet';

				// If the value is the same, toggle off the button.
				if ( value === currentAlphabetLetter ) {
					value = '';
				}

				updateFilters( { key: filter, value: value } );
			}

			const createButton = ( letter ) => {
				const attributes = {
					'class': 'reset alphabet-letter',
					'onclick': updateAlphabetFilter
				};

				if ( ! staffAlphabetically[ letter.toLowerCase() ] ) {
					attributes.disabled = true;
				}

				if ( letter === currentAlphabetLetter ) {
					attributes.class += ' active';
					attributes['aria-pressed'] = true;
				}

				return h(
					'button',
					attributes,
					letter
				);
			}

			return (
				<div class="staff-directory__alphabet-filter">
					<span class="screen-reader-text">Filter results by alphabet.</span>
					{ alphabet.map( createButton ) }
				</div>
			)
		}

		const ProgramList = ( { state, actions } ) => {
			const alphabet = [
				'A',
				'B',
				'C',
				'D',
				'E',
				'F',
				'G',
				'H',
				'I',
				'J',
				'K',
				'L',
				'M',
				'N',
				'O',
				'P',
				'Q',
				'R',
				'S',
				'T',
				'U',
				'V',
				'W',
				'X',
				'Y',
				'Z'
			];

			if ( state.filters.type.value === 'staff' ) {
				let { staff, staffAlphabetically, filters } = state;

				if ( ! state.initialRender ) {
					staff = filterPrograms( staff, filters );
					staffAlphabetically = groupAlphabetically( staff );
				} else {
					staffAlphabetically = { a: staffAlphabetically.a };

					setTimeout( function() {
						actions.updateRender( false );
					}, 1000 );
				}

				return (
					<div class="staff-directory__list">
						<header class="staff-directory__header">
							<h2 class="staff-directory__header-item">Member</h2>
							<h2 class="staff-directory__header-item">Department(s)</h2>
							<h2 class="staff-directory__header-item">Contact</h2>
						</header>
						{ alphabet.map( letter => letter.toLowerCase() ).filter( letter => staffAlphabetically[ letter ] ).map( letter => {
							return (
								<div class="staff-directory__section">
									<div class="staff-directory__letter-row">{ letter.toUpperCase() }</div>
									<div class="staff-directory__staff-container">
									{ staffAlphabetically[ letter ].map( staff => {
										return (
											<StaffItem staff={ staff } state={ state } />
										)
									} ) }
									</div>
								</div>
							);
						} ) }
					</div>
				)
			}

			if ( state.filters.type.value === 'offices' ) {
				let { staff, staffAlphabetically, filters, offices } = state;
				offices = filterOffices( Object.values( offices ), filters );
				const officesAlphabetically = groupOfficesAlphabetically( offices );

				return (
					<div class="staff-directory__list">
						<TypeFilter filters={ state.filters } actions={ actions } />
						<header class="staff-directory__office-header">
							<h2 class="staff-directory__header-item staff__department-header">Office</h2>
							<h2 class="staff-directory__header-item">Contact</h2>
							<h2 class="staff-directory__header-item">Office Location</h2>
						</header>
						{ alphabet.map( ( letter => letter.toLowerCase() ) ).filter( letter => !! officesAlphabetically[ letter ] ).map( letter => {
							return (
								<div class="staff-directory__section">
									<div class="staff-directory__letter-row">{ letter.toUpperCase() }</div>
									<div class="staff-directory__staff-container">
									{ officesAlphabetically[ letter ].map( office => {
										return (
											<OfficeItem office={ office } state={ state } />
										)
									} ) }
									</div>
								</div>
							);
						} ) }
					</div>
				)
			}
		}

		const StaffItem = ( { staff, state } ) => {
			let DepartmentComponent;

			if ( staff.DEPARTMENT ) {
				DepartmentComponent = <h3 data-header="Department" class="staff-directory__staff-value staff__department">{ staff.DEPARTMENT }</h3>;
			} else {
				DepartmentComponent = <h3 data-header="Department" class="staff-directory__staff-value staff__department"><span class="sr-only">Department not found.</span></h3>;
			}

			return (
				<div class="staff-directory__staff">
					<StaffName staff={ staff } />
					{ DepartmentComponent }
					<StaffContact staff={ staff } />
				</div>
			);
		}

		const StaffName = ( { staff } ) => {
			const fullName = staff.LAST_NAME + ', ' + staff.FIRST_NAME
			if ( staff.profile ) {
				const Name = ! staff.link ? <h3 class="staff__name">{ fullName }</h3> : <h3 class="staff__name"><a href={ staff.link.url } target={ staff.link.target } aria-label={ fullName }>{ fullName }</a></h3>;
				return (
					<div class="staff-directory__staff-value staff__name-profile">
						<img src={ staff.profile } class="staff-directory__staff-profile" width="80" height="80" alt={ fullName } />
						<div class="staff-directory__staff-data">
							{ Name }
							{ staff.TITLE ? <p class="staff__title">{ staff.TITLE }</p> : null }
						</div>
					</div>
				);
			} else {
				const Name = ! staff.link ? <h3 class="staff__name">{ fullName }</h3> : <h3 class="staff__name"><a href={ staff.link.url } target={ staff.link.target } aria-label={ fullName }>{ fullName }</a></h3>;
				return (
					<div class="staff-directory__staff-value staff-directory__staff-data">
						{ Name }
						{ staff.TITLE ? <p class="staff__title">{ staff.TITLE }</p> : null }
					</div>
				);
			}
		}

		const StaffContact = ( { staff } ) => {
      var email = (staff.EMAIL_ADDRESS || '')
        .replace(/\s*\[at\]\s*/ig, '@')
        .replace(/\s*\[dot\]\s*/ig, '.');

			return (
				<div data-header="Contact" class="staff-directory__staff-value staff-directory__staff-data">
					{ staff.EMAIL_ADDRESS ? <a href={ 'mailto:' + email } class="staff__contact">{ email }</a> : null }
					{ staff.PHONE_NUMBER ? <p class="staff__phone">{ formatPhoneNUmber( staff.PHONE_NUMBER ) }</p> : null }
				</div>

			);
		}

		const StaffLocation = ( { staff } ) => {
			if ( staff.location ) {
				return (
					<h3 data-header="Location" class="staff-directory__staff-value staff__location">{ staff.location }</h3>
				);
			} else {
				return (
					<h3 data-header="Location" class="staff-directory__staff-value staff__location">N/A</h3>
				);
			}
		}

		const OfficeItem = ( { office, state } ) => {
			const DepartmentComponent = <h3 class="staff-directory__staff-value staff__contact">Contact</h3>;
			const ContactComponent    = <h3 class="staff-directory__staff-value staff__location">Office Location</h3>;

			return (
				<div class="staff-directory__office">
					<OfficeName office={ office } />
					<OfficeContact office={ office } />
					<OfficeLocation office={ office } />
				</div>
			);
		}

		const OfficeName = ( { office } ) => {
			if ( office.name || office.link ) {
				return (
					<div class="staff-directory__staff-value staff-directory__staff-data office__name-container">
						{ office.name ? <h3 class="staff-directory__staff-value office__name">{ office.name }</h3> : null }
						{ office.link ? <Link cssClass="office__link arrow-link" link={ office.link } /> : null }
					</div>
				);
			}
		}

		const OfficeContact = ( { office } ) => {
			if ( office.email || office.phone ) {
        var email = office.email
          .replace(/\s*\[at\]\s*/ig, '@')
          .replace(/\s*\[dot\]\s*/ig, '.');

				return (
					<div data-header="Contact" class="staff-directory__staff-value staff-directory__staff-data">
						{ office.email ? <a href={ 'mailto:' + email } class="staff__contact">{ email }</a> : null }
						{ office.phone ? <p class="staff__phone">{ office.phone }</p> : null }
					</div>
				);
			}

			return (
				<h3 data-header="Contact" class="staff-directory__staff-value staff__location">N/A</h3>
			);
		}

		const OfficeLocation = ( { office } ) => {
			if ( office.location ) {
				return (
					<h3 data-header="Location" class="staff-directory__staff-value staff__location">{ office.location }</h3>
				);
			} else {
				return (
					<h3 data-header="Location" class="staff-directory__staff-value staff__location">N/A</h3>
				);
			}
		}

		const Link = ( { link, cssClass } ) => {
			if ( link.title ) {
				let className = 'link';
				className += ' ' + cssClass;

				return (
					<a class={ className } href={ link.url } target={ link.target } aria-label={ link.sr_text }>{ link.title }</a>
				);
			}

			return null;
		}

		const App = app( state, actions, view, document.getElementById( 'staff-directory' ) )

	} ( staffData ) );
}



// WEBPACK FOOTER //
// ./assets/js/staff-directory.js